/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
// Romanian
export default {
  'fabric.editor.mediaAddLink': 'Adăugare link',
  'fabric.editor.openLink': 'Deschideți linkul într-o filă nouă',
  'fabric.editor.unlink': 'Anulare link',
  'fabric.editor.editLink': 'Editați linkul',
  'fabric.editor.hyperlinkToolbarPlaceholder': 'Lipiți link sau căutați elementele vizualizate recent',
  'fabric.editor.linkPlaceholder': 'Lipire link',
  'fabric.editor.linkAddress': 'Adresă link',
  'fabric.editor.layoutFixedWidth': 'Înapoi la centru',
  'fabric.editor.layoutWide': 'Afișați lat',
  'fabric.editor.layoutFullWidth': 'Afișați lățime completă',
  'fabric.editor.alignImageRight': 'Aliniere la dreapta',
  'fabric.editor.alignImageCenter': 'Aliniere la centru',
  'fabric.editor.alignImageLeft': 'Aliniere la stânga',
  'fabric.editor.remove': 'Eliminare',
  'fabric.editor.visit': 'Deschidere link în fereastră nouă',
  'fabric.editor.editMode.inviteToEditButton.title': 'Invitați pentru editare',
  'fabric.editor.saveButton': 'Salvați',
  'fabric.editor.cancelButton': 'Anulați',
  'fabric.editor.alignment': 'Aliniere',
  'fabric.editor.normal': 'Text normal',
  'fabric.editor.heading1': 'Titlu 1',
  'fabric.editor.heading1Description': 'Utilizați pentru titlul superior',
  'fabric.editor.heading2': 'Titlu 2',
  'fabric.editor.heading2Description': 'Utilizați pentru secțiuni cheie',
  'fabric.editor.heading3': 'Titlu 3',
  'fabric.editor.heading3Description': 'Utilizați pentru subsecțiuni și titluri grupate',
  'fabric.editor.heading4': 'Titlu 4',
  'fabric.editor.heading4Description': 'Utilizați pentru subtitluri',
  'fabric.editor.heading5': 'Titlu 5',
  'fabric.editor.heading5Description': 'Utilizați pentru elemente din lista de grupare',
  'fabric.editor.heading6': 'Titlu 6',
  'fabric.editor.heading6Description': 'Utilizați pentru titlul inferior',
  'fabric.editor.blockquote': 'Citat',
  'fabric.editor.blockquote.description': 'Inserați citat sau referință',
  'fabric.editor.codeblock': 'Snippet cod',
  'fabric.editor.codeblock.description': 'Afișați codul cu evidențierea sintaxei',
  'fabric.editor.infoPanel': 'Panou info',
  'fabric.editor.infoPanel.description': 'Evidențiați informația într-un panou colorat',
  'fabric.editor.notePanel': 'Panou notițe',
  'fabric.editor.notePanel.description': 'Adăugați o notă într-un panou colorat',
  'fabric.editor.successPanel': 'Panou realizări',
  'fabric.editor.successPanel.description': 'Adăugați sfaturi într-un panou colorat',
  'fabric.editor.warningPanel': 'Panou avertismente',
  'fabric.editor.warningPanel.description': 'Adăugați o notă de precauție într-un panou colorat',
  'fabric.editor.errorPanel': 'Panou erori',
  'fabric.editor.errorPanel.description': 'Indicați erorile într-un panou colorat',
  'fabric.editor.other': 'Altele...',
  'fabric.editor.textStyles': 'Stiluri de text',
  'fabric.editor.displayBlock': 'Afișare ca dală',
  'fabric.editor.displayInline': 'Afișare ca link',
  'fabric.editor.displayLink': 'Afișare ca text',
  'fabric.editor.selectLanguage': 'Selectare limbă',
  'fabric.editor.edit': 'Editare',
  'fabric.editor.editorHelp': 'Ajutor Editor',
  'fabric.editor.helpDialogTips': 'Apăsați {keyMap} pentru a deschide rapid acest dialog la orice moment',
  'fabric.editor.keyboardShortcuts': 'Scurtături tastatură',
  'fabric.editor.markdown': 'Marcaj',
  'fabric.editor.undo': 'Revocare',
  'fabric.editor.redo': 'Refacere',
  'fabric.editor.pastePlainText': 'Lipire text simplu',
  'fabric.editor.altText': 'Text alternativ',
  'fabric.editor.closeHelpDialog': 'Închidere dialog de ajutor',
  'fabric.editor.quickInsert': 'Inserare rapidă',
  'fabric.editor.displayText': 'Text de afișat',
  'fabric.editor.clearLinkText': 'Ștergeți textul',
  'fabric.editor.clearLink': 'Ștergeți linkul',
  'fabric.editor.action': 'Articol acțiune',
  'fabric.editor.action.description': 'Creați și alocați articole acțiune',
  'fabric.editor.link': 'Link',
  'fabric.editor.link.description': 'Inserare link',
  'fabric.editor.filesAndImages': 'Fișiere și imagini',
  'fabric.editor.filesAndImages.description': 'Adăugați imagini și alte fișiere în pagina dvs.',
  'fabric.editor.image': 'Imagine',
  'fabric.editor.mention': 'Mențiune',
  'fabric.editor.mention.description': 'Menționați pe cineva pentru a le trimite o notificare',
  'fabric.editor.emoji': 'Emoji',
  'fabric.editor.emoji.description': 'Utilizați emoji-uri pentru a exprima idei 🎉 și emoții 😄',
  'fabric.editor.table': 'Tabel',
  'fabric.editor.table.description': 'Inserați un tabel',
  'fabric.editor.decision': 'Decizie',
  'fabric.editor.decision.description': 'Capturați deciziile pentru a fi ușor de urmărit',
  'fabric.editor.feedbackDialog': 'Oferă feedback',
  'fabric.editor.feedbackDialog.description': 'Spune-ne despre experiența ta în folosirea noului editor',
  'fabric.editor.horizontalRule': 'Divizor',
  'fabric.editor.horizontalRule.description': 'Separați conținutul cu o linie orizontală',
  'fabric.editor.date': 'Dată',
  'fabric.editor.date.description': 'Adăugați o dată cu ajutorul unui calendar',
  'fabric.editor.placeholderText': 'Substituent',
  'fabric.editor.columns': 'Aspecte',
  'fabric.editor.columns.description': 'Structurați pagina utilizând secțiuni',
  'fabric.editor.status': 'Stare',
  'fabric.editor.status.description': 'Introduceți o etichetă de stare personalizată',
  'fabric.editor.viewMore': 'Vezi mai multe',
  'fabric.editor.insertMenu': 'Inserare',
  'fabric.editor.twoColumns': 'Două coloane',
  'fabric.editor.threeColumns': 'Trei coloane',
  'fabric.editor.rightSidebar': 'Bară laterală dreapta',
  'fabric.editor.leftSidebar': 'Bară laterală stânga',
  'fabric.editor.threeColumnsWithSidebars': 'Trei coloane cu bară laterală',
  'fabric.editor.unorderedList': 'Listă cu marcatori',
  'fabric.editor.unorderedList.description': 'Creați o listă neordonată',
  'fabric.editor.orderedList': 'Listă numerotată',
  'fabric.editor.orderedList.description': 'Creați o listă ordonată',
  'fabric.editor.lists': 'Liste',
  'fabric.editor.annotate': 'Adnotare',
  'fabric.editor.wrapLeft': 'Încadrare stânga',
  'fabric.editor.wrapRight': 'Încadrare dreapta',
  'fabric.editor.backLink': 'Reveniți',
  'fabric.editor.info': 'Informații',
  'fabric.editor.note': 'Notă',
  'fabric.editor.success': 'Succes',
  'fabric.editor.warning': 'Avertisment',
  'fabric.editor.error': 'Eroare',
  'fabric.editor.placeholderTextPlaceholder': 'Adăugare text substituent',
  'fabric.editor.statusPlaceholder': 'Setați o stare',
  'fabric.editor.tableOptions': 'Opțiuni tabel',
  'fabric.editor.headerRow': 'Rând antet',
  'fabric.editor.headerColumn': 'Coloană antet',
  'fabric.editor.numberedColumn': 'Coloană numerotată',
  'fabric.editor.cellBackground': 'Fundal celulă',
  'fabric.editor.mergeCells': 'Îmbinare celule',
  'fabric.editor.splitCell': 'Împărțire celulă',
  'fabric.editor.clearCells': '{0, plural, one{Golire celulă} few{Golire celule} other{Golire celule}}',
  'fabric.editor.sortColumnASC': 'Sort column A → Z',
  'fabric.editor.sortColumnDESC': 'Sort column Z → A',
  'fabric.editor.canNotSortTable': "⚠️ You can't sort a table with merged cells",
  'fabric.editor.insertColumn': 'Inserare coloană',
  'fabric.editor.removeColumns': '{0, plural, one{Eliminare coloană} few{Eliminare coloane} other{Eliminare coloane}}',
  'fabric.editor.insertRow': 'Inserare rând',
  'fabric.editor.removeRows': '{0, plural, one{Eliminare rând} few{Eliminare rânduri} other{Eliminare rânduri}}',
  'fabric.editor.cellOptions': 'Opțiuni celulă',
  'fabric.editor.decisionPlaceholder': 'Adăugați o decizie...',
  'fabric.editor.taskPlaceholder': 'Introduceți acțiunea și folosiți semnul @ pentru a o atribui cuiva.',
  'fabric.editor.textColor': 'Culoare text',
  'fabric.editor.underline': 'Subliniere',
  'fabric.editor.strike': 'Tăiere cu o linie',
  'fabric.editor.code': 'Cod',
  'fabric.editor.subscript': 'Indice',
  'fabric.editor.superscript': 'Exponent',
  'fabric.editor.clearFormatting': 'Ștergere formatare',
  'fabric.editor.moreFormatting': 'Mai multe opțiuni formatare',
  'fabric.editor.bold': 'Bold',
  'fabric.editor.italic': 'Italic',
  'fabric.editor.selected': 'Selectate'
};